import React from 'react';
import { sendGAEvent, sendGALinkClickEvent } from '@noths/polaris-client-google-analytics';
import type {
  LinkCarouselItemClickPayload,
  LinkCarouselProps,
  NavigatePayload,
} from '@noths/polaris-client-ribbons-design-system';
import { LinkCarousel } from '@noths/polaris-client-ribbons-design-system';

export enum LinkCarouselTrackingCategory {
  ChildCategory = 'Child Category',
  RelatedCategory = 'Related Category',
}
export interface LinkCarouselContainerProps extends Omit<LinkCarouselProps, 'items'> {
  links: LinkCarouselProps['items'];
  trackingCategory: LinkCarouselTrackingCategory;
}

export const LinkCarouselContainer = ({
  links,
  title,
  trackingCategory,
}: LinkCarouselContainerProps) => {
  const onVisible = () => {
    sendGAEvent({
      event: 'custom_event',
      event_category: trackingCategory,
      event_action: 'Impression',
      event_label: 'not set',
      seo_link_source: 'similar.ai',
    });
  };

  const onNavigate = ({ navigation }: NavigatePayload) => {
    sendGAEvent({
      event: 'custom_event',
      event_category: trackingCategory,
      event_action: navigation.type,
      event_label: navigation.direction,
    });
  };

  const onItemClick = (
    evt: React.MouseEvent<HTMLAnchorElement | HTMLButtonElement>,
    { index }: LinkCarouselItemClickPayload,
  ) => {
    sendGALinkClickEvent(evt, {
      event: 'custom_event',
      event_category: trackingCategory,
      event_action: 'Link Click',
      event_label: links[index].text,
      destination_URL: links[index].href!.substring(0, 99),
      seo_link_source: 'similar.ai',
    });
  };

  return links.length > 0 ? (
    <LinkCarousel
      items={links}
      onItemClick={onItemClick}
      onNavigate={onNavigate}
      onVisible={onVisible}
      title={title}
    />
  ) : null;
};
